<template>
  <div
    class="main-container"
    :style="{ backgroundImage: 'url(' + cbg + ')' }"
    :class="$store.state.isMiniapp ? '' : 'phoneTop andriodTop'"
  >
    <div class="main-header">
      <div class="debug" @click="handleClick"></div>
      <div class="header-des flex_direction_center" @click="jump('/history')">
        <div>创作</div>
        <div class="mt_2">记录</div>
      </div>
    </div>
    <div class="content">
      <div class="config">
        <div class="config-title flex_between">
          <div class="title-text flex_start">
            <div class="title-line-wrap flex_center">
              <div class="title-line"></div>
              <div class="text-content">选择宠物</div>
            </div>
          </div>
        </div>
        <div class="select-label mt_8">
          <div
            class="select-label-item"
            v-for="item in petsLabel.slice(0, 7)"
            :key="item.id"
          >
            <div
              class="img-wrap"
              :class="selectLabel == item.value ? 'item-active' : ''"
              @click="handleSelectPet(item)"
            >
              <img class="item-img" :src="item.pic_url" alt="" />
            </div>
            <div class="item-text">{{ item.show_name }}</div>
          </div>
          <div class="select-label-item">
            <div
              class="img-wrap"
              :class="selectLabel == 'sx' ? 'item-active' : ''"
              @click="handleSelectPet({ id: 'sx' })"
            >
              <img
                class="item-img"
                :src="
                  sxId
                    ? petsLabel.find((item) => item.value == sxId).pic_url
                    : sxdefault
                "
                alt=""
              />
              <div class="popup-item-mask" v-if="sxId">更换宠物</div>
            </div>
            <div class="item-text">更多毛孩子</div>
          </div>
        </div>
        <div class="config-title flex_between mt_16">
          <div class="title-text flex_between">
            <div class="title-line-wrap flex_center">
              <div class="title-line"></div>
              <div class="text-content">创意推荐</div>
            </div>
            <div class="change flex_center" @click="nextPage">
              <img
                class="change-icon"
                src="@/assets/images/icon/change-icon.png"
                alt=""
              />
              <div class="change-text">换一换</div>
            </div>
          </div>
        </div>
        <div class="recommend mt_8" v-if="labelList.length">
          {{ labelList[page_index - 1].prompt_message }}
        </div>
        <div
          v-if="generateImgs.length == 0"
          class="generate-btn mt_12"
          @click="_generateImgTask"
        >
          生成图片
        </div>
        <div class="img-task" v-if="visibleImgTask">
          <div class="config-title flex_between mt_16">
            <div class="title-text flex_between">
              <div class="title-line-wrap flex_center">
                <div class="title-line"></div>
                <div class="text-content">选择图片</div>
              </div>
              <div class="change flex_center" @click="retryGenerate">
                <img
                  class="change-icon"
                  src="@/assets/images/icon/change-icon.png"
                  alt=""
                />
                <div class="change-text">重新生成</div>
              </div>
            </div>
          </div>
          <div class="generate-imgs mt_8">
            <div
              class="generate-img-item flex_center"
              v-for="(item, index) in generateImgs"
              :key="index"
            >
              <div
                class="generate-loading flex_direction_center"
                v-if="item.task_status == 0"
              >
                <img
                  class="loading-icon"
                  src="@/hidream/common/assets/image/icon/loading.gif"
                  alt=""
                />
                <div>
                  生成中...{{
                    new Decimal(item.task_completion * 100).toFixed(1)
                  }}%
                </div>
              </div>
              <div
                class="generate-img"
                :class="
                  currentSelectImgIndex == index ? 'generate-img-active' : ''
                "
                @click="changeImg(index)"
                v-else
              >
                <img class="generate-img" :src="item.image" alt="" />
              </div>
            </div>
          </div>
          <div
            class="button-text-v2 generate-btn mt_12"
            :class="isGenerate ? '' : 'button-disabled'"
            @click="_generateTask"
          >
            生成视频
          </div>
        </div>
      </div>
    </div>
    <div class="example-wrap">
      <div class="example flex_center mt_16">
        <img class="tem-bg" src="@/assets/images/main/tem-bg.png" alt="" />
      </div>
      <div class="example-list">
        <div
          class="example-item flex_direction_center"
          v-for="item in exampleList"
          :key="item.id"
        >
          <div
            class="example-img-container flex_center"
            @click="playVideo(item)"
          >
            <img class="example-img" :src="item.cover" alt="" />
            <img class="player-icon" :src="StartIcon" alt="" />
          </div>
          <div class="example-button flex_center mt_8">
            <div
              class="button-text flex_center"
              @click="_generateTaskTry(item)"
            >
              我也试试
            </div>
          </div>
        </div>
      </div>
    </div>
    <videoView
      v-if="videoVisible"
      :videoUrl="videoUrl"
      @hideVideo="hideVideo"
      :waterText="waterText"
    >
      <div class="view-footer flex_center">
        <div
          class="view-footer-button flex_center"
          @click="
            _generateTaskTry({
              cover: videoImg,
              video: videoUrl,
            })
          "
        >
          我也试试
        </div>
      </div>
    </videoView>
    <van-popup v-model="visiblePopup" round position="bottom">
      <div class="popup-container">
        <div class="popup-header flex_between">
          <div class="header-title">更多毛孩子</div>
          <img
            @click="visiblePopup = false"
            class="close-icon"
            src="@/assets/images/icon/close.png"
            alt=""
          />
        </div>
        <div class="popup-content">
          <div
            class="content-item"
            v-for="item in petsLabel"
            :key="item.id"
            @click="handleSelectSx(item)"
          >
            <img class="content-icon" :src="item.pic_url" alt="" />
            <div class="item-title">{{ item.show_name }}</div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import sxdefault from "@/assets/images/main/sx-default.png";
import StartIcon from "@/hidream/common/assets/image/icon/start-icon.png";
import StopIccon from "@/hidream/common/assets/image/icon/stop-icon.png";
import {
  generateImgTask,
  getPrompt,
  getWorks,
  getSetting,
  getPetsList,
} from "@/api/main";
import Vue from 'vue';
import videoView from "@/hidream/common/components/VideoView";
import { changeUrl, defaultVideoUrl, defaultSnapshot } from "@/utils/index";
import { fakeProgressBar, GetQueryString } from "@/utils";
import { MAX_GENERAT_LEN } from "@/global";
import { Decimal } from "decimal.js";
import bgImg from "@/assets/images/main/banner-bg.png";
import jsCookie from "js-cookie";
import { getTaskIdMg } from "@/hidream/utils/index";
import { onMounted } from "vue";
import RiskControlPlugin from "@/utils/riskControl";
Vue.use(RiskControlPlugin, {
    // 可以在这里覆盖默认配置
    // productId: '正式环境ID',
    // businessId: '正式业务ID'
});
export default {
  name: "Main",
  components: {
    videoView,
  },
  data() {
    return {
      risk_token: null,
        
      sxdefault,
      visiblePopup: false,
      Decimal,
      petsLabel: [],
      defaultSnapshot,
      defaultVideoUrl,
      changeUrl,
      page_index: 1,
      page_index_works: 1,
      StartIcon,
      StopIccon,
      videoVisible: false,
      videoUrl: "",
      videoImg: "",
      exampleList: [],
      labelList: [],
      prompt: "",
      isGenerate: true,
      generateImgs: [],
      selectLabel: "",
      curentPromptPage: 1,
      taskImgTime: 9,
      visibleImgTask: false,
      currentSelectImgIndex: 0,
      sxId: "",
      clickCount: 0,
      lastClickTime: 0,
      testVar: "",
    };
  },
  setup() {
    onMounted(() => {
      // const act = GetQueryString("act");
      // if (act && act == "generate_img") {
      //   this._generateImgTask();
      // }
    });
  },
  mounted() {
    this.$store.commit("setImgTasksv2", []);
    this.$store.commit("setTasksv2", []);
    this._getSetting();
    this._getPetsList();
    this._getWorks();

    const vuid = GetQueryString("vuid") ? GetQueryString("vuid") : jsCookie.get('vuid');
    const loginUrl = localStorage.getItem("loginUrl");

    if (loginUrl == "migulogin") {
      this.loginTrack(vuid, 0);
      localStorage.setItem("loginUrl", "");
    }
    if (vuid) {
      this.enterTrack(vuid);
    } else {
      this.enterTrack("");
    }
    this.$riskControl.initSDK()
    //this.getToken();
    // 获取taskId
    // 11-24
    // if (!this.$route.query.taskId) {
    //   getTaskIdMg("replace", "/main?btoken=" + this.$route.query.btoken + "&vuid=" + vuid, "mg-mczx");
    //   return;
    // }

  },
  computed: {
    cbg() {
      return localStorage.getItem("banner_url")
        ? localStorage.getItem("banner_url")
        : bgImg;
    },
    waterText() {
      return localStorage.getItem("watermark_word")
        ? localStorage.getItem("watermark_word")
        : "内容由AI生成";
    },
  },
  methods: {
    async getRiskToken() {
      const result = await this.$riskControl.getToken();
      console.log('risk_token riskToken:', JSON.stringify(result));
      // 兼容不同 SDK 返回字段名，提取常用 token 字段
      const risk_token = result.token  || null;
      this.risk_token = risk_token;
      // 同步到 vuex，方便其他页面使用（存原始字符串）
      try {
        this.$store.commit('setRiskToken', risk_token);
      } catch (e) {}
      return result;
    },
    _getPetsList() {
      getPetsList({ type: "pet" }).then((res) => {
        this.petsLabel = res.result.templates;
        this.selectLabel = res.result.templates[0]?.value;
        this._getPrompt();
      });
    },
    _getSetting() {
      getSetting().then((res) => {
        if (!localStorage.getItem("banner_url")) {
          localStorage.setItem("banner_url", res.result.banner_url);
        } else {
          const banner_url = localStorage.getItem("banner_url");
          if (banner_url != res.result.banner_url) {
            localStorage.setItem("banner_url", res.result.banner_url);
          }
        }
        localStorage.setItem("watermark_word", res.result.watermark_word);
      });
    },
    handleClick() {
      const currentTime = Date.now(); // 当前时间戳
      if (currentTime - this.lastClickTime > 1000) {
        // 如果间隔超过 1 秒，重置计数器
        this.clickCount = 0;
      }

      this.clickCount++; // 增加计数
      this.lastClickTime = currentTime; // 更新最后点击时间
      if (this.clickCount === 30) {
        const VConsole = require("vconsole");
        new VConsole();
      }
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },

    changeImg(index) {
      this.currentSelectImgIndex = index;
    },
    handleSelectPet(item) {
      this.selectLabel = item.value;
      this.page_index = 1;
      if (item.id == "sx") {
        this.selectLabel = item.id;
        this.visiblePopup = true;
        return;
      }
      this._getPrompt();
    },
    handleSelectSx(item) {
      this.sxId = item.value;
      this.visiblePopup = false;
      this._getPrompt();
    },
    playVideo(item) {
      console.log(item);
      this.videoVisible = true;
      this.videoUrl = item.video;
      this.videoImg = item.params.image;
    },
    hideVideo() {
      this.videoVisible = false;
    },
    jump(url) {
      this.$router.push(url);
    },
    nextPage() {
      console.log("---", this.labelList);
      if (this.labelList.length == this.page_index) {
        this.page_index = 1;
      } else {
        this.page_index++;
      }
      console.log();
    },
    retryGenerate() {
      if (!this.isGenerate) {
        this.$toast("生成中,请稍后");
        return;
      }
      const len = this.labelList[this.page_index - 1].prompt_info.length;
      if (len == this.curentPromptPage) {
        this.curentPromptPage = 1;
      } else {
        this.curentPromptPage++;
      }
      this._generateImgTask();
    },
    createImgTask() {
      this.$store.commit("setImgTasks", {
        task_id: 1,
      });
      this.visibleImgTask = true;
      this.generateImgs.forEach((item) => {
        fakeProgressBar(this.taskImgTime, (value) => {
          if (value >= 1) {
            item.task_completion = 1;
            item.task_status = 1;
            this.isGenerate = true;
            this.$store.commit("setImgTasksv2", []);
          } else {
            item.task_completion = value;
          }
        });
      });
    },

    async _generateImgTask2() {
      if (!this.$route.query.taskId) {
        await this._getTaskId();
      }

      // await this._generateImgTask();
    },

    async _generateImgTask() {
      if (this.$store.state.imgTasks.length >= MAX_GENERAT_LEN) {
        this.$toast("生成中,请稍后");
        return;
      }
      if (!this.isGenerate) return;

      // 上报 DirectlyTrack
      // const vuid = GetQueryString("vuid") ? GetQueryString("vuid") : jsCookie.get('vuid');
      // 11-24
      // this.submitDirectlyTrack(vuid, this.$route.query.taskId,"");
      
      this.isGenerate = false;
      const currentMsg = this.labelList[this.page_index - 1].prompt_message;

      const index = this.labelList.findIndex(
        (item) => item.prompt_message == currentMsg
      );
      try {
        let res = await generateImgTask({
          prompt_id:
            this.labelList[index].prompt_info[this.curentPromptPage - 1]
              .prompt_id,
          params: {
            batch_size: 2,
            last_result: this.generateImgs.map((item) => item.image),
          },
        });

        // 上报 submitTrack
        // 11-24
        // this.submitTrack(vuid, this.$route.query.taskId, this.selectLabel);

        if (res.code === 200) {
          res.data.sub_task_results.forEach((item) => {
            item.task_status = 0;
            item.task_completion = 0;
          });

          this.generateImgs = res.data.sub_task_results;
          this.createImgTask();
        }
      } catch (error) {
        this.isGenerate = true;
      }
    },
    async _generateTaskTry(item) {
      if (this.$store.state.tasks.length >= MAX_GENERAT_LEN) {
        this.$dialog.alert({
          title: "温馨提示",
          message: "上次任务还未完成，可到[创作记录]查看进度",
          confirmButtonColor: "#038DF9",
          showConfirmButton: false,
        });
        setTimeout(() => {
          this.$dialog.close();
        }, 1500);
        return;
      }
      if (!this.isGenerate) {
        this.$toast("生成中,请稍后");
        return;
      }
      this.isGenerate = false;
      this.$store.commit("setImage", item.params.image);
      this.isGenerate = true;
      this.$router.push("/history");
    },
    async _generateTask() {
      if (!this.isGenerate) return;
      this.isGenerate = false;

      // 上报 submitTrack
      const vuid = GetQueryString("vuid") ? GetQueryString("vuid") : jsCookie.get('vuid');
      // 获取风控 token
      const tokenRes = await this.getRiskToken();
      // token 和 rcToken 已在 getToken 中保存并同步到 vuex
      // 11-24
      // this.submitTrack(vuid, this.$route.query.taskId, this.generateImgs[this.currentSelectImgIndex].image);

      // console.log("生成视频");
      // console.log(this.generateImgs[this.currentSelectImgIndex].image);

      // console.log("image");
      // console.log(this.$store.state.image);

      // console.log("video");
      // console.log(this.$store.state.video);

      this.$store.commit(
        "setImage",
        this.generateImgs[this.currentSelectImgIndex].image
      );

      // 上报 submitCompleteTrack
      // this.submitCompleteTrack(vuid, this.$route.query.taskId, this.generateImgs[this.currentSelectImgIndex].image, "", videoUrl);

      this.isGenerate = true;
      this.$router.push("/history");
    },
    async _getPrompt() {
      let res = await getPrompt({
        pet: this.selectLabel == "sx" ? this.sxId : this.selectLabel,
      });
      if (res.code === 200) {
        this.labelList = res.data;
      }
    },
    async _getWorks() {
      let res = await getWorks({
        page_index: this.page_index_works,
        page_size: 6,
      });
      if (res.code === 200) {
        res.data.list.forEach((item) => {
          item.video = item.result_video;
        });
        this.exampleList = res.data.list;
      }
    },

    async _getTaskId() {
      const vuid = GetQueryString("vuid") ? GetQueryString("vuid") : jsCookie.get('vuid');

      if (!this.$route.query.taskId) {
        await getTaskIdMg("replace", "/main?btoken=" + this.$route.query.btoken + "&vuid=" + vuid + "&action=generate_img", "mg-mczx");

        // this._generateImgTask();
      }
    },

    enterTrack(vuid) {
      _amberTrack("music_aigc_enter",[{
        EK:"appId",
        EV:'20c388c5b45e316d42605e09ddd37437'
      },
      {
        EK:"scene",
        EV:'AI_HR_MCZX'
      },
      {
        EK:"vuid",
        EV:vuid
      },
      {
        EK:"channel",
        EV:'014X031'
      },   
      {
        EK:"triggerType",
        EV:"1"
      }]);
    },

    loginTrack(vuid, loginResult) {
      _amberTrack("music_aigc_login",[{
        EK:"appId",
        EV:'20c388c5b45e316d42605e09ddd37437'
      },
      {
        EK:"scene",
        EV:'AI_HR_MCZX'
      },
      {
        EK:"vuid",
        EV:vuid
      },
      {
        EK:"channel",
        EV:'014X031'
      },   
      {
        EK:"triggerType",
        EV:"2"
      },   
      {
        EK:"loginResult",
        EV:loginResult
      }]);
    },

    // submitDirectlyTrack(vuid, taskId, templateId) {
    //   _amberTrack("music_aigc_submit_task_directly",[{
    //     EK:"appId",
    //     EV:'20c388c5b45e316d42605e09ddd37437'
    //   },
    //   {
    //     EK:"scene",
    //     EV:'AI_HR_MCZX'
    //   },
    //   {
    //     EK:"vuid",
    //     EV:vuid
    //   },
    //   {
    //     EK:"channel",
    //     EV:'014X031'
    //   },   
    //   {
    //     EK:"triggerType",
    //     EV:"2"
    //   },   
    //   {
    //     EK:"taskId",
    //     EV:taskId
    //   },   
    //   {
    //     EK:"templateId",
    //     EV:templateId
    //   }]);
    // },
    // submitTrack(vuid, taskId, templateId) {
    //   _amberTrack("music_aigc_submit_task",[{
    //     EK:"appId",
    //     EV:'20c388c5b45e316d42605e09ddd37437'
    //   },
    //   {
    //     EK:"scene",
    //     EV:'AI_HR_MCZX'
    //   },
    //   {
    //     EK:"vuid",
    //     EV:vuid
    //   },
    //   {
    //     EK:"channel",
    //     EV:'014X031'
    //   },   
    //   {
    //     EK:"triggerType",
    //     EV:"2"
    //   },   
    //   {
    //     EK:"taskId",
    //     EV:taskId
    //   },   
    //   {
    //     EK:"templateId",
    //     EV:templateId
    //   }]);
    // },
  },
};
</script>
<style lang="scss" scoped>
.generate-loading {
  color: $orange-font-color;
}
.debug {
  position: absolute;
  top: 0;
  left: 0;
  height: 50px;
  width: 50px;
}

.popup-item-mask {
  position: absolute;
  bottom: 2px;
  padding: 2px 4px;
  color: #ffffff;
  font-size: 10px;
  border-radius: 4px;
  background: rgba(25, 26, 27, 0.8);
}
.button-text {
  background: $card-content-bg-color;
  color: $red-font-color;
}
.popup-content {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  margin-top: 8px;

  .content-item {
    text-align: center;

    .content-icon {
      width: 80px;
      height: 80px;
      border-radius: 6px;
    }

    .content-title {
      color: #191a1b;
      font-size: 14px;
      margin-top: 4px;
    }
  }
}

.popup-container {
  padding: 16px;
  position: relative;
  padding-bottom: 30px;

  .popup-title {
    color: #4d4d4d;
    font-size: 16px;
  }
}

.popup-header {
  top: 0;
  left: 0;
  right: 0;
  background-color: #fff;

  .header-title {
    font-size: 16px;
    color: #191a1b;
    font-weight: 500;
  }

  .close-icon {
    width: 22px;
    height: 22px;
  }
}

.button-disabled {
  opacity: 0.4;
}

.generate-img {
  width: 100%;
  height: 100%;
  border-radius: 12px;
  box-sizing: border-box;
}

.select-label {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
}
.select-label-item {
  text-align: center;

  .img-wrap {
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
    aspect-ratio: 1/1;
    // width: 80px;
    // height: 80px;
    display: flex;
    justify-content: center;
  }

  .item-active {
    border: 2px solid $orange-font-color;
    padding: 2px;
    border-radius: 10px;
  }

  .item-img {
    width: 100%;
    height: 100%;
    border-radius: 6px;
    box-sizing: border-box;
    object-fit: cover;
  }

  .item-text {
    font-size: 14px;
    color: #4d4d4d;
    margin-top: 4px;
  }
}
.generate-img-active {
  border: 2px solid $orange-font-color;
  padding: 2px;
  border-radius: 12px;
}
.view-footer {
  position: absolute;
  bottom: 40px;
  left: 0;
  right: 0;
  padding: 0 16px;
  gap: 8px;

  .view-footer-button {
    padding: 10px 0px;
    background: $bg-linear-color;
    color: #ffffff;
    font-size: 16px;
    border-radius: 12px;
    width: 70%;
    margin: 0 auto;
  }
}

.area-wrap {
  position: fixed;
  left: 0;
  right: 0;
  z-index: 100;
}

.main-container {
  padding-bottom: 30px;
  background-color: $red-bg-color;
  background-repeat: no-repeat;
  background-size: 100% auto;

  .main-header {
    position: relative;
    height: 242px;

    .banner {
      width: 100%;
      height: 100%;
    }

    .header-des {
      position: absolute;
      top: 98px;
      right: 0px;
      font-size: 14px;
      background: $bg-linear-color;
      text-align: center;
      padding: 4px 8px;
      border-radius: 6px 0px 0px 6px;
      border-width: 1px 0px 1px 1px;
      border-style: solid;
      border-color: #ffffff;
      color: #ffffff;
    }
  }

  .content {
    padding: 0 16px;

    .config {
      position: relative;
      z-index: 1;
      background-color: $card-content-bg-color;
      border-radius: 20px;
      padding: 12px;

      .config-title {
        .title-text {
          width: 100%;

          .text-content {
            position: relative;
            color: #191a1b;
            font-size: 16px;
            z-index: 1;
          }

          .text-default {
            font-size: 12px;
            color: #4d4d4d;
          }

          .title-line-wrap {
            position: relative;

            .title-line {
              width: 6px;
              height: 14px;
              border-radius: 16px;
              background: linear-gradient(159deg, #ff5b22 0%, #fc9c3b 100%);
              margin-right: 4px;
            }
          }
        }

        .change-icon {
          width: 16px;
          height: 16px;
          margin-right: 4px;
        }

        .change-text {
          font-size: 12px;
          color: #038df9;
        }
      }

      .recommend {
        color: #4d4d4d;
        font-size: 14px;
        background: $card-content-bg-color-2;
        padding: 4px 8px;
        border-radius: 8px;
        line-height: 22px;
      }

      .generate-btn {
        width: 100%;
        border-radius: 12px;
        box-sizing: border-box;
        text-align: center;
        margin-left: 0;
        padding: 10px 0;
        background: $bg-linear-color;
        color: #fff;
      }

      .generate-imgs {
        display: grid;
        gap: 12px;
        grid-template-columns: repeat(2, 1fr);

        .generate-img-item {
          aspect-ratio: 9 / 16;
          background: $card-content-bg-color-2;
          border-radius: 12px;
          font-size: 12px;

          .loading-icon {
            width: 48px;
            height: 48px;
          }
        }
      }

      .generate {
        width: 100%;
        height: 40px;
        border-radius: 12px;
        background-size: 100% 100%;
        color: $red-font-color;
        background: $bg-linear-color;
        font-size: 16px;
      }
    }
  }

  .example-wrap {
    // padding: 0 16px;
    .example {
      .tem-bg {
        width: 193px;
        height: 92px;
      }
    }

    .example-list {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      padding: 0 12px;

      .example-item {
        margin-bottom: 16px;
      }

      // gap: 8px;
      .example-img-container {
        position: relative;

        .example-img {
          // width: 100%;
          height: 290px;
          border-radius: 16px;
          aspect-ratio: 9 / 16;
        }

        .player-icon {
          height: 44px;
          width: 44px;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          opacity: 0.8;
        }
      }

      .example-button {
        width: 92%;
        height: 32px;
        border-radius: 16px;
      }
    }
  }
}
</style>
